import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { useNavigate } from "react-router-dom";
import Shop from "../../Services/shopServices";
import { Table as TB, message, Popconfirm } from "antd";

function Shopkeepers(props) {
  const columns = [
    {
      dataIndex: "name",
      title: "Shop Name",
      responsive: ["sm"],
    },
    {
      dataIndex: "phone",
      responsive: ["sm"],
      title: "Phone",
    },
    {
      dataIndex: "ownership",
      responsive: ["sm"],
      title: "Ownership",
    },
    {
      dataIndex: "contract_start",
      responsive: ["sm"],
      title: "Contract Start Date",
    },
    {
      dataIndex: "contract_end",
      responsive: ["sm"],
      title: "Contract End Date",
    },
    {
      dataIndex: "status",
      responsive: ["sm"],
      title: "Status",
    },
    {
      dataIndex: "action",
      responsive: ["sm"],
      title: "Action",
    },
  ];

  const navigate = useNavigate();
  const [shopList, setShopList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 5,
    },
  });
  const handleTableChange = (pagination, filter, sorter) => {
    setIsFilter(false);
    setTableParams({ pagination, filter, ...sorter });
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setShopList([]);
    }
  };
  const getShopList = async () => {
    setLoading(true);
    await Shop.getAllShopkeepers("64ea2e40fc4e94de4396d212")
      .then((data) => {
        setLoading(false);

        setShopList(data.data.data.shopkeepers);
        console.log("shopList", data.data.data.shopkeepers);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  const removeShopkeeper = async (shopkeeperid) => {
    alert(shopkeeperid);
    setLoading(true);
    await Shop.removeShopkeeper("64ea2e40fc4e94de4396d212", shopkeeperid)
      .then((data) => {
        setLoading(false);
        getShopList();
        message.success("Shopkeeper removed from the shop");
        console.log("Shopkeeper removed from the shop", data.data);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    getShopList();
  }, []);

  return (
    <>
      {loading && (
        <div id="global-loader">
          <div class="whirly-loader"> </div>
        </div>
      )}
      <div class="page-wrapper">
        <div class="content">
          <div class="page-header">
            <div class="page-title">
              <h4>Shop Shopkeepers List</h4>
              <h6>Manage shop Shopkeepers</h6>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="table-top">
                <div class="search-set">
                  <div class="search-path">
                    <a class="btn btn-filter" id="filter_search">
                      <img src="/assets/img/icons/filter.svg" alt="img" />
                      <span>
                        <img src="/assets/img/icons/closes.svg" alt="img" />
                      </span>
                    </a>
                  </div>
                  <div class="search-input">
                    <a class="btn btn-searchset">
                      <img src="/assets/img/icons/search-white.svg" alt="img" />
                    </a>
                  </div>
                </div>
                <div class="wordset">
                  <ul>
                    <li>
                      <a
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="pdf"
                      >
                        <img src="/assets/img/icons/pdf.svg" alt="img" />
                      </a>
                    </li>
                    <li>
                      <a
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="excel"
                      >
                        <img src="/assets/img/icons/excel.svg" alt="img" />
                      </a>
                    </li>
                    <li>
                      <a
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="print"
                      >
                        <img src="/assets/img/icons/printer.svg" alt="img" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="card mb-0" id="filter_inputs">
                <div class="card-body pb-0">
                  <div class="row">
                    <div class="col-lg-12 col-sm-12">
                      <div class="row">
                        <div class="col-lg col-sm-6 col-12">
                          <div class="form-group">
                            <select class="select">
                              <option>Choose Shop</option>
                              <option>Macbook pro</option>
                              <option>Orange</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg col-sm-6 col-12">
                          <div class="form-group">
                            <select class="select">
                              <option>Choose Category</option>
                              <option>Computers</option>
                              <option>Fruits</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg col-sm-6 col-12">
                          <div class="form-group">
                            <select class="select">
                              <option>Choose Sub Category</option>
                              <option>Computer</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg col-sm-6 col-12">
                          <div class="form-group">
                            <select class="select">
                              <option>Brand</option>
                              <option>N/D</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg col-sm-6 col-12 ">
                          <div class="form-group">
                            <select class="select">
                              <option>Price</option>
                              <option>150.00</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg-1 col-sm-6 col-12">
                          <div class="form-group">
                            <a class="btn btn-filters ms-auto">
                              <img
                                src="/assets/img/icons/search-whites.svg"
                                alt="img"
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <BootstrapTable
                classes="table-responsive"
                bootstrap4
                bordered={false}
                keyField="_id"
                data={shopList}
                columns={columns}
                selectRow={{ mode: "checkbox" }}
              /> */}

              <TB
                size="large"
                columns={columns}
                pagination={tableParams.pagination}
                onChange={handleTableChange}
                loading={loading}
                dataSource={shopList?.map((item, index) => ({
                  key: item._id,

                  name: <p>{item.shopkeeper.name}</p>,

                  phone: item.shopkeeper.phone,
                  address: item.shopkeeper.address,
                  ownership: item.shopkeeper.ownership,
                  contract_start: item.shopkeeper.contract.start_date,
                  contract_end: item.shopkeeper.contract.end_date,
                  shops: item.shopkeeper.shops.map(
                    (shop) => `${shop.shop_number}-${shop.name}`
                  ),
                  status: item.active ? "Active" : "Inactive",

                  // rental_history: item?.rental_history[0]?.amount,
                  //   shops: item.shops.map((shop) => `${shop.shop_number}-`),
                  action: (
                    <div>
                      <Popconfirm
                        title="Delete the task"
                        description="Are you sure to delete this task?"
                        onConfirm={() => removeShopkeeper(item.shopkeeper._id)}
                        onCancel={() => message.error("Cancelled")}
                        okText="Yes"
                        cancelText="No"
                      >
                        <abbr title="Remove Shopkeeper from Shop">
                          <button
                            style={{
                              backgroundColor: "transparent",
                              border: "0px",
                            }}
                            // onClick={() => removeShopkeeper(item.shopkeeper._id)}
                          >
                            <img src="assets/img/icons/delete.svg"></img>
                          </button>
                        </abbr>
                      </Popconfirm>
                    </div>
                  ),
                }))}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Shopkeepers;
